export default __webpack_public_path__ + "static/media/cardSuscripcion.b78e60f1.png";